import React from 'react';

import { Currency, Gap, Text } from '@common/components';

type Props = {
  displayAsLumpSum: boolean;
  formattedLumpSumRate?: string | null;
  perHourRateCents?: number;
  formattedPerHourRate?: string | null;
  tierLabel?: string | null;
};

/**
 * Renders a shift incentive rate as either a lump sum ("$200/shift") or a
 * per-hour rate ("$50.00/hr"), with an optional tier label stacked below in
 * secondary text.
 */
export function IncentiveRateDisplay({
  displayAsLumpSum,
  formattedLumpSumRate,
  perHourRateCents,
  formattedPerHourRate,
  tierLabel,
}: Props) {
  if (displayAsLumpSum && formattedLumpSumRate) {
    return (
      <Gap vertical size="xs">
        <span>{formattedLumpSumRate}/shift</span>
        {tierLabel && <Text secondary>{tierLabel}</Text>}
      </Gap>
    );
  }

  const perHourDisplay =
    perHourRateCents !== undefined ? (
      <span>
        <Currency value={perHourRateCents / 100} />
        /hr
      </span>
    ) : formattedPerHourRate ? (
      <span>{formattedPerHourRate}/hr</span>
    ) : null;

  if (!perHourDisplay) return null;

  return (
    <Gap vertical size="xs">
      {perHourDisplay}
      {tierLabel && <Text secondary>{tierLabel}</Text>}
    </Gap>
  );
}
